module.exports = __webpack_public_path__ + "img/computer.24d17e83.jpg";